<template>
  <div class="side">
    <!-- 中部内容块 -->
    <div class="middle-section">
      <div style="height: 45vh">
        <div class="table-header">
          <div>检测中心</div>

          <!-- <el-popover placement="right" title="选择时间段" trigger="click">
            <el-button slot="reference">click 激活</el-button>
            <div class="toInfo" slot="reference">筛选</div>
          </el-popover> -->
          <!-- <i class="el-icon-arrow-right"></i> -->
        </div>

        <div class="container">
          <div class="status-cards">
            <div class="card">
              <div class="status-header">
                <div class="status-indicator warning"></div>
                <div class="status-title" @click="jump('/dece')">
                  检测仪表盘
                </div>
              </div>
              <div class="server-count">{{ driverCount }}</div>
            </div>
            <div class="card">
              <div class="status-header">
                <div class="status-indicator offline"></div>
                <div class="status-title">劳务队数</div>
              </div>
              <div class="server-count" @click="toInfo('workerRating')">
                {{ teamCount }}
              </div>
            </div>
            <div class="card">
              <div class="status-header">
                <div class="status-indicator online"></div>
                <div class="status-title">设备在线</div>
              </div>
              <div class="server-count" @click="toInfo('ieDevice')">
                {{ onlineCount }}
              </div>
            </div>
            <div class="card">
              <div class="status-header">
                <div class="status-indicator totalcount"></div>
                <div class="status-title">设备总数</div>
              </div>
              <div class="server-count" @click="toInfo('ieDevice')">
                {{ totalCount }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 45vh">
        <div class="table-header">
          <div>工作超过10小时统计</div>
          <!-- <div class="toInfo">筛选</div> -->
          <!-- <i class="el-icon-arrow-right"></i> -->
        </div>

        <div class="table-list">
          <!-- 表头 -->
          <div class="table-title">
            <div class="col" style="width: 33%">驾驶员</div>
            <div class="col" style="width: 33%">工作日期</div>
            <div class="col" style="width: 33%">工时</div>
          </div>
          <div class="table-filter">
            <el-date-picker
              :append-to-body="isFullscreen ? false : true"
              clearable
              v-model="workPickerDate"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :editable="false"
              unlink-panels
              :picker-options="pickerOptions"
              @change="handleDateChange($event, 'worktime')"
            >
            </el-date-picker>
          </div>
          <!-- 滚动列表区域 -->
          <div class="table-body">
            <div class="scroll-wrapper1">
              <!-- 原始数据 -->
              <div
                class="table-row"
                v-for="(item, index) in worktimeoutList"
                :key="'c' + index"
              >
                <div
                  class="col driverName"
                  style="width: 33%"
                  @click.stop="toInfo('worktime', item)"
                >
                  {{ item.driverName }}
                </div>
                <div class="col" style="width: 33%">
                  {{ item.workTime }}
                </div>
                <div class="col" style="width: 33%">
                  {{ item.workAttendance }}
                </div>
                <!-- <div class="col"></div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="chart_part"> -->
        <!-- <div class="flex" style="margin-bottom: 3vh"> -->
        <!-- <div class="chart">
            <ChartsColumn :ytitle="'分'" :data="workerRatingData" />
          </div> -->
        <!-- </div> -->
        <!-- </div> -->
      </div>
    </div>

    <!-- 弹框组件 -->
    <div class="modal-overlay" v-if="clockOpen">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">打卡记录</div>
        </div>
        <div class="modal-pro">项目:{{ clockProName }}</div>
        <div class="modal-body">
          <el-table :data="clockList" max-height="200" v-loading="loading">
            <el-table-column label="驾驶员" align="center" prop="driverName" />
            <el-table-column label="打卡类型" align="center" prop="onFlag">
              <template slot-scope="scope">
                {{ getOptionsType(scope.row.onFlag, clockTypeOptions) }}
              </template>
            </el-table-column>
            <el-table-column label="时间" align="center" prop="time" />
            <el-table-column label="打卡照片" align="center" prop="photo">
              <template slot-scope="scope">
                <image-preview
                  :src="fileShowUrl + scope.row.photo"
                  :width="50"
                  :height="50"
                />
              </template>
            </el-table-column>
          </el-table>
          <!-- <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getClockList"
          /> -->
        </div>

        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="clockClose">关 闭</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { listScore } from '@/api/iemanage/scoreStatistics'
// import { getProject } from '@/api/manage/project'

// import { worktimeout, clockException } from '@/api/iemanage/drivers_screen'
// import { listClock } from '@/api/iemanageclock/clock'
export default {
  name: 'LeftPanel',
  components: {
    //   ChartsColumn: () => import('../charts_drivers/ChartsColumn.vue'),
    //   ChartsPie: () => import('../charts_drivers/ChartsPie.vue'),
    // StackedColumn: () => import('../charts_drivers/StackedColumn.vue')
  },
  props: {
    beginTime: {
      type: String,
      required: true
    },
    endTime: {
      type: String,
      required: true
    },
    // 是否全屏
    isFullscreen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      fileShowUrl: process.env.VUE_APP_BASE_API + '/file',
      clockProName: null,
      clockProId: null,
      projectId: null,
      dataInterval: null,
      paused: false,
      requestStatus: false,
      pausedBeh: false,
      clockOpen: false,
      loading: false,
      clockList: [],
      total: 0,
      driverRatingData: [], //驾驶员评分数据
      workerRatingData: [], //劳务队评分数据
      projectRatingData: [], //项目评分数据
      behaviorList: [],
      clockTypeOptions: [
        {
          dictValue: 1,
          dictLabel: '上班打卡'
        },
        {
          dictValue: 2,
          dictLabel: '下班打卡'
        }
      ],
      worktimeoutList: [],
      pickerDate: [],
      workPickerDate: [],
      queryParams: {
        pageNum: 1,
        pageSize: 20
      },
      queryClockParams: {
        pageSize: -1
      },
      queryWorkParams: {
        pageNum: 1,
        pageSize: 20
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      }
    }
  },

  mounted() {
    // console.log(this.isFullscreen)
    // // 轮询
    // this.getClockExceptionFn()
    // this.getWorktimeoutFn()
    // this.$nextTick(() => {
    //   if (this.beginTime && this.endTime) {
    //     this.projectRating()
    //     this.workerRating()
    //   }
    // })
  },
  beforeDestroy() {
    // clearInterval(this.dataInterval)
  },
  methods: {
    // // 打卡异常统计
    // getClockExceptionFn() {
    //   clockException(this.queryParams).then((res) => {
    //     if (res.code == 200) {
    //       this.behaviorList = res.data
    //     }
    //   })
    // },
    // // 工作超过10小时统计
    // getWorktimeoutFn() {
    //   worktimeout(this.queryWorkParams).then((res) => {
    //     if (res.code == 200) {
    //       this.worktimeoutList = res.data
    //     }
    //   })
    // },

    // /** 项目评分 */
    // projectRating() {
    //   let params = {
    //     pageNum: 1,
    //     pageSize: -1,
    //     type: '1',
    //     beginTime: this.beginTime,
    //     endTime: this.endTime
    //   }

    //   return new Promise((resolve) => {
    //     listScore(params).then((response) => {
    //       this.projectRatingData = response.data.records.map((item) => {
    //         return {
    //           label: item.name,
    //           value: item.aveScore
    //         }
    //       })
    //       console.log(this.projectRatingData, '项目评分')
    //     })

    //     resolve()
    //   })
    // },

    // /** 劳务队评分 */
    // workerRating() {
    //   let params = {
    //     projectId: null,
    //     deviceId: null,
    //     pageNum: 1,
    //     pageSize: -1,
    //     type: '2',
    //     beginTime: this.beginTime,
    //     endTime: this.endTime
    //   }

    //   return new Promise((resolve) => {
    //     listScore(params).then((response) => {
    //       this.workerRatingData = response.data.records.map((item) => {
    //         return {
    //           label: item.name || '',
    //           value: item.aveScore
    //         }
    //       })
    //       console.log(response.data.records, '劳务队评分')
    //     })

    //     resolve()
    //   })
    // },

    // /** 查询打卡记录列表 */
    // async getClockList() {
    //   if (this.requestStatus) {
    //     // 利用 return 终止函数继续运行
    //     return false
    //   }
    //   console.log('按钮点击函数执行')
    //   // 执行函数
    //   this.requestStatus = true
    //   setTimeout(() => {
    //     // 模拟执行完毕
    //     // 改变 requestStatus
    //     this.requestStatus = false
    //   }, 1000)
    //   let proInfo = await getProject(this.clockProId)
    //   console.log(proInfo)
    //   if (proInfo && proInfo.data) this.clockProName = proInfo.data.projectName
    //   this.loading = true
    //   this.clockList = []
    //   listClock(this.queryClockParams)
    //     .then((response) => {
    //       this.clockList = response.data
    //       this.total = response.total

    //       this.loading = false
    //       this.clockOpen = true
    //     })
    //     .catch(() => {
    //       this.clockList = []
    //       this.total = 0
    //       this.loading = false
    //     })
    // },
    resize() {},
    /** 图表去详情 */
    toInfo(el, item) {
      console.log(el, item, '图表去详情')
      this.clockProId = null

      if (el == 'ieDevice') {
        //(智能终端设备)
        this.$router.push('/manage/iemanage/smart-device')
      } else if (el == 'drivers') {
        //(塔司管理)
        this.$router.push('/manage/iemanage/drivers-page')
      } else if (el == 'driverRating') {
        //（驾驶员评分） 带参数
        this.$router.push({
          path:
            '/manage/iemanage/score-statistics-drivers?projectId=' +
            this.projectId
        })
      } else if (el == 'workerRating') {
        //（劳务队评分） 带参数
        this.$router.push({
          path:
            '/manage/iemanage/score-statistics?type=2&projectId=' +
            this.projectId
          // path: '/manage/iemanage/acount-team?projectId=' + this.projectId
        })
      } else if (el == 'driverWorking') {
        //（驾驶员工时） 带参数
        this.$router.push({
          path: '/manage/iemanage/clock?projectId=' + this.projectId
        })
      } else if (el == 'projectRating') {
        // 项目评分
        // this.$router.push(`/manage/iemanage/acount-project`)
        this.$router.push({
          path:
            '/manage/iemanage/score-statistics?type=1&projectId=' +
            this.projectId
        })
      } else if (el == 'projectWorking') {
        // 项目工时
        this.$router.push(`/manage/iemanage/work-project`)
      }
      // 劳务队带项目参数
      else if (el == 'workerAge') {
        this.$router.push({
          path: '/manage/iemanage/age-team?projectId=' + this.projectId
        })
      } else if (el == 'workerCard') {
        this.$router.push({
          path: '/manage/iemanage/card-team?projectId=' + this.projectId
        })
      } else if (el == 'workerSex') {
        this.$router.push({
          path: '/manage/iemanage/sex-team?projectId=' + this.projectId
        })
      } else if (el == 'projectAge') {
        this.$router.push(`/manage/iemanage/age-project`)
      } else if (el == 'projectCard') {
        this.$router.push(`/manage/iemanage/card-project`)
      } else if (el == 'projectSex') {
        this.$router.push(`/manage/iemanage/sex-project`)
      } else if (el == 'clock') {
        // 打卡详情
        this.queryClockParams.driverId = item.driverId
        this.queryClockParams.params = {}
        this.queryClockParams.params.beginTime = item.workTime
        this.queryClockParams.params.endTime = item.workTime
        this.clockProId = item.projectId

        this.getClockList()

        // this.$router.push(
        //   `/manage/iemanageclock/clock-info?driverId=` +
        //     item.driverId +
        //     '&beginTime=' +
        //     this.queryParams.params.beginTime +
        //     '&endTime=' +
        //     this.queryParams.params.endTime
        // )
      } else if (el == 'worktime') {
        // 打卡详情
        this.queryClockParams.driverId = item.driverId
        this.queryClockParams.params = {}
        this.queryClockParams.params.beginTime = item.workTime
        this.queryClockParams.params.endTime = item.workTime
        this.clockProId = item.projectId
        this.getClockList()

        // this.$router.push(
        //   `/manage/iemanageclock/clock-info?driverId=` +
        //     item.driverId +
        //     '&beginTime=' +
        //     this.queryParams.params.beginTime +
        //     '&endTime=' +
        //     this.queryParams.params.endTime
        // )
      }
    },
    // 自定义字典展示
    getOptionsType(e, options) {
      if (options && options.length > 0) {
        for (var i = 0; i < options.length; i++) {
          if (options[i].dictValue == e) {
            return options[i].dictLabel
          }
        }
      }
    },
    clockClose() {
      this.clockOpen = false
    },

    //选择日期事件
    handleDateChange(dialogPickerDate, type) {
      if (type == 'clock') {
        if (dialogPickerDate == null) {
          this.pickerDate = []
          this.queryParams.params = {}
        }
        if (dialogPickerDate && dialogPickerDate.length > 0) {
          this.queryParams.params = {}
          this.queryParams.params.beginTime = this.pickerDate[0]
          this.queryParams.params.endTime = this.pickerDate[1]
        }
        this.getClockExceptionFn()
      } else if (type == 'worktime') {
        this.queryWorkParams.pageNum = 1
        this.queryWorkParams.pageSize = 20
        if (dialogPickerDate == null) {
          this.workPickerDate = []
          this.queryWorkParams.params = {}
        }
        if (dialogPickerDate && dialogPickerDate.length > 0) {
          this.queryWorkParams.params = {}
          this.queryWorkParams.params.beginTime = this.workPickerDate[0]
          this.queryWorkParams.params.endTime = this.workPickerDate[1]
        }
        this.getWorktimeoutFn()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* .left-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
} */
/* ✅ 表头样式 */
.table-header {
  display: flex;
  // background: #e6f0fa; /* 浅蓝灰背景 */
  margin: 10px 0;
  padding: 0 20px;
  font-size: 16px;
  align-items: center;
  justify-content: center;
  // color: #000;
  font-weight: bold;
  // border: 2px solid;
  background: linear-gradient(
    to right,
    rgba(85, 144, 217, 0.4),
    rgba(85, 144, 217, 0.05)
  );
  position: relative;
  // border-image-slice: 1;
  // transition: all 0.4s ease;
  // background: #005eb8;

  border-radius: 16px 16px 0 0;
  height: 32px;
}
/* ✅ 通用列样式 */
.col {
  // padding: 0 8px;
  overflow: hidden;
  display: flex;
  width: 25%;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  text-overflow: ellipsis;
}
.table-list {
  display: flex;
  border-radius: 10px;

  flex-direction: column;
  border: 1px solid #ccc;
}
.table-title {
  display: flex;
  background: rgba(85, 144, 217, 0.1); /* 浅蓝灰背景 */
  padding: 0 20px;
  font-size: 16px;
  align-items: center;
  justify-content: space-around;

  height: 32px;
}

.driverName {
  color: #005eb8;
}

/* 中部内容 */
.middle-section {
  flex: 1;
  // padding: 10px 0;
  // margin: 1vh 0;
  width: 100%;

  overflow: hidden;
}
.panel-box {
  display: flex;
  justify-content: space-between;
}
.panel-title {
  font-size: 14px;
  font-weight: bold;
  color: #005eb8;
  margin-bottom: 10px;
}
.toInfo {
  // color: #409eff;
  color: #999;
  position: absolute;
  right: 0;
  font-size: 12px;
}
.toInfo:hover {
  cursor: pointer;
}
.driver-list {
  list-style: none;
  padding-left: 0;
  font-size: 14px;
  color: #333;
}

/* 底部信息 */
.bottom-section {
  padding: 10px;
}
.summary-list {
  list-style: none;
  padding-left: 0;
  font-size: 14px;
  color: #444;
  line-height: 1.6;
}
.chart_part {
  margin-top: 1vh;
  margin-bottom: 1vh;
  .chart {
    // border: #e6e8ec 1px solid;
    // box-sizing: border-box;
    width: 100%;
    height: 30vh;
    background-color: transparent;
    // border-radius: 10px;
    // padding: 0 10px;
    // margin-right: 1%;
  }
}
/* ✅ 滚动区域样式 */
.table-body {
  height: 26vh;
  width: 100%;
  overflow: auto;
  position: relative;
  background-color: transparent;
}
.table-body::-webkit-scrollbar {
  display: none;
}

/* ✅ 表格行 */
.table-row {
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  padding: 8px 0;
  border-bottom: 1px solid #d0dce7;
}
.table-filter {
  width: 100%;
  display: flex;
  ::v-deep .el-range-input {
    background: transparent;
  }
  ::v-deep .el-range-editor.el-input__inner {
    background-color: transparent;
  }
}
// .........../.
/* 弹框样式 */
.modal-overlay {
  position: absolute;
  top: 30vh;
  left: 0;
  width: 600px;
  height: 30vh;

  // background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}
.modal-content {
  background: white;
  border-radius: 15px;
  width: 100%;
  // max-width: 500px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.4s ease;
  position: relative;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 10px;
  padding: 10px;
}
.modal-title {
  // font-size: 1rem;
  // color: #2c3e50;
  line-height: 24px;
  font-size: 18px;
  color: #303133;
}
modal-pro {
  padding: 10px;

  line-height: 20px;
  font-size: 16px;
  color: #2c3e50;
}
.modal-body {
  color: #34495e;
  line-height: 1.6;
  margin-bottom: 25px;
}
.container {
  width: 100%;
  // max-width: 1200px;
  // text-align: center;
  display: flex;
  flex-direction: column;
}

.status-cards {
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 25px;
}

.card {
  // background: rgba(255, 255, 255, 0.95);
  // border-radius: 16px;
  // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  padding: 10px;
  // width: 300px;
  transition: all 0.3s ease;
  // backdrop-filter: blur(10px);
  // border: 1px solid rgba(255, 255, 255, 0.2);
}

.card:hover {
  transform: translateY(-5px);
  // box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
}

.status-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
}

.online {
  background: linear-gradient(135deg, #00b09b, #96c93d);
  box-shadow: 0 0 10px rgba(0, 176, 155, 0.5);
}

.offline {
  background: linear-gradient(135deg, #8e0e00, #1f1c18);
}

.warning {
  background: linear-gradient(135deg, #ff8c00, #ffcc00);
}
.totalcount {
  background: linear-gradient(135deg, #3498db, #2980b9);
}
.status-title {
  font-weight: 600;
  color: #333;
  font-size: 1rem;
}

.server-count {
  cursor: pointer;
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  text-align: center;
}
.server-count:hover {
  color: #005eb8;
}
.server-label {
  color: #7f8c8d;
  font-size: 1rem;
  margin-bottom: 20px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 50px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #3498db, #2980b9);
  color: white;
}

.btn-secondary {
  background: #ecf0f1;
  color: #7f8c8d;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.chart-container {
  height: 100px;
  margin: 20px 0;
}
</style>
